import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { Card } from "../common/Card";
import { PieChartShimmer } from "../../common/reportDashBShimmer/PieChartShimmer";
import { WalletSectionError } from "./WalletSectionError";
import { WALLET_CHART_COLORS } from "./walletReportUtils";

export function WalletDistributionSection({
  distributionState,
  topHoldersState,
  transactionTypes,
  topHolders,
}) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
        <span className="mb-6 text-[#1A1A1A] text-lg">
          Transaction Distribution
        </span>
        {distributionState.loading ? (
          <PieChartShimmer />
        ) : distributionState.error ? (
          <WalletSectionError
            message={distributionState.message}
            onRetry={distributionState.onRetry}
          />
        ) : transactionTypes.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={transactionTypes}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={100}
                fill="#8884d8"
                paddingAngle={3}
                dataKey="value"
                label={({ name, percentage }) => `${name} ${percentage}%`}
              >
                {transactionTypes.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={WALLET_CHART_COLORS[index % WALLET_CHART_COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: "white",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                }}
                formatter={(value) => `$${value.toLocaleString()}`}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-64 flex items-center justify-center text-gray-400">
            No transaction data available
          </div>
        )}
      </Card>

      <Card className="p-6 bg-white rounded-lg shadow-sm border border-gray-100">
        <span className="mb-6 text-[#1A1A1A] text-lg">Top Wallet Holders</span>
        {topHoldersState.loading ? (
          <PieChartShimmer />
        ) : topHoldersState.error ? (
          <WalletSectionError
            message={topHoldersState.message}
            onRetry={topHoldersState.onRetry}
          />
        ) : topHolders.length > 0 ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={topHolders} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis type="number" stroke="#6B7280" />
              <YAxis
                dataKey="entity"
                type="category"
                width={130}
                stroke="#6B7280"
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "white",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                }}
                formatter={(value) => `$${value.toLocaleString()}`}
              />
              <Bar
                dataKey="approximateBalance"
                fill="#1E61DC"
                radius={[0, 4, 4, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-64 flex items-center justify-center text-gray-400">
            No transaction data available
          </div>
        )}
      </Card>
    </div>
  );
}
